import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useResourcesContext } from "app/contexts/resources";

export function RepresentacionGeograficaSelect({
  label = "Representación geográfica",
  value = 0,
  onChange = () => {},
  disabled = false,
}) {
  const { representacionesGeograficas } = useResourcesContext();

  return (
    <FormControl size="small" fullWidth required>
      <InputLabel id="representacion-geografica-label">{label}</InputLabel>

      <Select
        labelId="representacion-geografica-label"
        label={label}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {representacionesGeograficas.results.map((representacion) => (
          <MenuItem
            key={representacion.representacion_geografica_id}
            value={representacion.representacion_geografica_id}
          >
            {representacion.representacion_geografica_nombre}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
